import { render, staticRenderFns } from "./ConfigurationForm119.vue?vue&type=template&id=80995dce&scoped=true&lang=pug&"
import script from "./ConfigurationForm119.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationForm119.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationForm119.vue?vue&type=style&index=0&id=80995dce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80995dce",
  null
  
)

export default component.exports